import React from "react";
import loading from "../../photos/Spinner-1.9s-137px.gif";
import { AdminLogStateContext } from "../../context/AdminDashboard/AdminLogContext";
import Icon from "../atoms/Icon";
import Pagination from "../main/Pagination";
import EmptyS from "../atoms/EmptyS";
import {isEmpty} from '../../clases/validator'
const Log = ({emptyText,Hempty,dataLog ,loaded}) => {
  // const {  } = AdminLogStateContext();
  if(!isEmpty(dataLog)){
    return(
        <div className={`flex flex-col justify-center items-center  m-7.5px  ${Hempty}`}>
        <EmptyS text={emptyText} />
      </div>
    )
  } else{
    return (
        <div className="flex flex-col gap-5" dir="rtl">
          <div className="flex row gap-3.6 text-13 text-dark-blue-200  ">
            <div className="flex-row flex bg-gray-chart-300 py-3.4 w-1/6 pr-6 gap-2.5 items-center rounded-sm ">
              <Icon iconName="calendar" />
              <p>ساعت و تاریخ</p>{" "}
            </div>
            <div className="flex-row flex bg-gray-chart-300 py-3.4 w-5/6 pr-6 gap-2.5 items-center rounded-sm">
              <Icon iconName="noted" /> <p>توضیحات فعالیت</p>
            </div>
          </div>
          {!loaded ? (
            <div className="flex justify-center items-center w-24 h-304 m-auto bg-transparent">
              <img src={loading} alt="" />
            </div>
          ) : (
            <>
              {dataLog.map((log, index) => (
                <div
                  key={index}
                  className="flex flex-row items-center gap-3.5 text-13 text-dark-blue-200 ">
                  <p className="bg-gray-chart-200 w-1/6 py-3.4 pr-6 rounded-sm font-normal">
                    {log.date}
                  </p>
                  <p className="bg-gray-chart-200 w-5/6 py-3.4 pr-6 rounded-sm font-normal">
                    {log.text}
                  </p>
                </div>
              ))}
            </>
          )}
        </div>
      );
  }
 
};

export default Log;
